import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-20 md:py-28 bg-background-800">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12">
          <div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-2">
              最新爆料
            </h2>
            <p className="text-white/50 text-sm">全网最快爆料节奏，每日更新不停歇</p>
          </div>
          <span className="text-white/30 text-sm mt-2 md:mt-0">
            今日更新 {cardsData.length} 条
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cardsData.map((card) => (
            <a
              key={card.id}
              href="#cards"
              className="group block bg-background-900 rounded-2xl overflow-hidden hover:scale-[1.02] transition-transform duration-300 cursor-pointer"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className={`px-2.5 py-1 text-xs font-medium rounded-full ${
                    card.hot
                      ? 'bg-accent-500 text-background-50'
                      : 'bg-white/20 text-white'
                  }`}>
                    {card.tag}
                  </span>
                </div>
                {card.hot && (
                  <div className="absolute top-3 right-3">
                    <span className="flex items-center gap-1 px-2 py-1 bg-primary-500 text-white text-xs font-medium rounded-full">
                      <i className="ri-fire-line text-xs"></i>热
                    </span>
                  </div>
                )}
              </div>
              <div className="p-4">
                <h3 className="text-white font-semibold text-sm leading-snug mb-2 line-clamp-2 group-hover:text-accent-400 transition-colors">
                  {card.title}
                </h3>
                <p className="text-white/45 text-xs leading-relaxed line-clamp-2 mb-3">
                  {card.summary}
                </p>
                <span className="text-white/30 text-xs">{card.date}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}